import { render, staticRenderFns } from "./renja_pengeluaran.vue?vue&type=template&id=33babad0&"
import script from "./renja_pengeluaran.vue?vue&type=script&lang=js&"
export * from "./renja_pengeluaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports